export const Logo = ({ size = 32, className = '' }) => {
  const textSize = size >= 40 ? 'text-xl sm:text-2xl' : 'text-lg';
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <span
        className="inline-flex items-center justify-center rounded-xl bg-muted/80 border border-border shadow-[inset_0_0_0_1px_hsl(var(--background)/0.6)] flex-shrink-0 overflow-hidden"
        style={{ width: size, height: size, padding: Math.max(2, Math.round(size * 0.1)) }}
        aria-hidden="true"
      >
        <img
          src="/logo.png"
          alt=""
          className="w-full h-full object-contain"
          style={{ filter: 'saturate(0.85) contrast(1.05)' }}
        />
      </span>
      <span className={`font-heading font-semibold tracking-tight leading-none ${textSize}`}>My Flow Habit</span>
    </div>
  );
};
